"use client";
import React, { useMemo } from "react";
import { EnvironmentOutlined } from "@ant-design/icons";
import { useRouter } from "next/navigation";
import { Grid } from "antd";
import { OverlayView, OverlayViewF } from "@react-google-maps/api";
import { useBrowse } from "../../lib/hooks";
import { getLocationBookingPath } from "@/consts/serviceHubs";

interface MarkerProps {
  lat: number;
  lng: number;
  pathId: string;
  name: string;
  address: string;
  image?: string;
  below?: boolean;
}

const Marker = ({
  pathId,
  lat,
  lng,
  name,
  address,
  image,
  below,
}: MarkerProps) => {
  const router = useRouter();
  const screens = Grid.useBreakpoint();
  const { idOnCard, idOnMarker, place, setMarker, removeMarker, setPlace, serviceSlug } =
    useBrowse();
  const isHighlighted =
    pathId === idOnCard || pathId === idOnMarker || place?.pathId === pathId;
  // Stable coordinates prevent hover updates from remounting the overlay.
  const position = useMemo(() => ({ lat, lng }), [lat, lng]);
  return (
    <OverlayViewF
      position={position}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
      zIndex={isHighlighted ? 10 : 1}
    >
      <button
        type="button"
        className={`location-map-pin ${isHighlighted ? "is-active" : ""} ${below ? "is-below" : ""}`}
        aria-label={`${name} location`}
        onClick={() =>
          screens.md
            ? router.push(getLocationBookingPath(pathId, serviceSlug))
            : setPlace({ pathId, name, address, image, lat, lng })
        }
        onMouseEnter={() => setMarker(pathId)}
        onMouseLeave={removeMarker}
        onFocus={() => setMarker(pathId)}
        onBlur={removeMarker}
      >
        <EnvironmentOutlined aria-hidden="true" />
        <span>{name}</span>
      </button>
    </OverlayViewF>
  );
};

export default Marker;
